import React, { useState, useCallback, useEffect } from "react";
import { TabPane } from "reactstrap";
import { openDetailModal } from "components/tabs";
import { Resultset } from "components/response";
import { useSearchSimilar } from "hooks";

const SimilarTab = ({ responseId, tabId, className }) => {
  const [detail, setDetail] = useState(null);
  const [result, search] = useSearchSimilar();
  const execute = useCallback(
    (page = 1, append = false) => search(responseId, page, append),
    [responseId, search]
  );
  useEffect(() => {
    execute();
  }, [execute]);
  return (
    <TabPane tabId={tabId} className={className}>
      <Resultset
        setDetail={(response) => {
          openDetailModal(response);
          return setDetail(response);
        }}
        status={result.status}
        result={result}
        execute={execute}
        detailId={detail != null ? detail.id : -1}
      />
    </TabPane>
  );
};

export { SimilarTab };
